import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { targetId: String }

  connect() {
    this.dropdown = document.getElementById(this.targetIdValue)

    if (!this.dropdown) return

    if (window.matchMedia("(min-width: 1024px)").matches) {
      this.element.addEventListener("mouseenter", this.show)
      this.element.addEventListener("mouseleave", this.hide)
    } else {
      this.element.addEventListener("click", this.handleClick)
    }
  }

  disconnect() {
    this.element.removeEventListener("mouseenter", this.show)
    this.element.removeEventListener("mouseleave", this.hide)
    this.element.removeEventListener("click", this.handleClick)
  }

  handleClick = (event) => {
    // Prevent toggling if a link inside the dropdown is clicked
    if (event.target.closest(`#${this.targetIdValue} a`)) {
      return // Let link click pass through
    }

    this.dropdown.classList.toggle("hidden")
  }

  show = () => {
    this.dropdown.classList.remove("hidden")
  }

  hide = () => {
    this.dropdown.classList.add("hidden")
  }
}
